export const NavData = [
  {
    title: 'Home Page',
    link: 'https://darum.ng/',
  },
  {
    title: 'Return Policies',
    link: 'https://darum.ng/',
  },
  {
    title: 'About Us',
    link: 'https://darum.ng/',
  },
];
